export default {
  payWelfareText: 'Phúc Lợi Nạp',
  blackFridayDiscount: 'Ưu đãi Black Friday',
  shareGift: 'Chia sẻ có quà',
  vipWeeklyWelfare: 'Ưu đãi VIP Tuần',
  exchangeCoupon: 'Đổi phiếu giảm giá',
  firstPayOff: 'Lần đầu mua hưởng 15%OFF cao',
  blackFridayEvent: 'HĐ Black Friday',
  limitedTimeOff: 'Ưu đãi hạn giờ 10%OFF',
  claimCoupon: 'Nhận phiếu giảm giá',
  blackFridayTimedCoupon: 'Phiếu giảm Black Friday',
  timeLeft: 'HĐ còn:',
  claimTimeCoupon: 'Nhận phiếu giảm hạn giờ 10%OFF',
  points: 'Điểm còn: ${point}',
  costPointTip: 'Tiêu hao điểm nhận phiếu giảm mốc ưu đãi bất kỳ',
  maxPointTip: 'Mỗi tài khoản tối đa dùng 500 điểm',
  discountOff: '10%OFF',
  highestDiscount: 'Ưu đãi cao nhất ${discount} ',
  needPoint: 'Cần ${point} điểm',
  changeCurrency: 'Đổi loại tiền',
  claim: 'Nhận',
  claimSucc: 'Nhận thành công',
  claimFail: 'Nhận thất bại',
  pointNotEnough: 'Điểm không đủ',
  afterClaimPoint: 'Điểm sau khi nhận: ${point}',
  footTips1: 'Mỗi giao dịch chỉ được dùng 1 phiếu giảm giá',
  footTips2: 'Khi mua voucher không thể dùng phiếu giảm giá',
  footTips3: 'Quyền giải thích cuối cùng thuộc về đội vận hành',
  ruleTitleText: 'Điều kiện hoạt động',
  ruleTime: 'Thời gian HĐ: 24-11-2023 0:00 ～ 26-11-2023 23:59 (UTC)',
  bfRuleText1:
    '1.Trong HĐ, tài khoản đăng nhập lần đầu trang nạp chính thức nhận 400 điểm, dùng để đổi phiếu giảm giá, tối đa được dùng 500 điểm;',
  bfRuleText2:
    '2.Trong HĐ, dùng điểm Black Friday có thể đổi phiếu giảm giá mốc bất kỳ, mốc ưu đãi càng cao, điểm cần càng nhiều. Sau khi đổi thành công sẽ trừ điểm tương ứng.',
  bfRuleText3:
    '3.Mỗi giao dịch chỉ được dùng 1 phiếu ưu đãi, voucher sản phẩm không thể dùng trong Black Friday',
  bfRuleText4: '4.Phiếu giảm giá Black Day chỉ dùng cho loại tiền sau:',
  ableCoinsType: 'USD,JPY,KRW,TWD,EUR,HKD,GBP,CAD,AUD,RUB,MYR,THB,PLN,IDR',
  bfRuleText5:
    '5.Đổi thành công, không hỗ trợ đổi loại tiền, cũng không hỗ trợ hoàn trả điểm, xin hãy để ý mốc ưu đã và điểm tiêu hao;',
  bfRuleText6: '6.Phiếu giảm giá Black Friday có hiệu lực 7 ngày, hãy để ý dùng;',
  bfRuleText7: '7.Quyền giải thích cuối cùng thuộc về đội vận hành;',
  thanksTip:
    'Cảm ơn bạn đã tham gia, nhiều hoạt động nạp khác vui lòng theo dõi nhóm chính thức',
  exchangePoints: 'Đổi phiếu giảm giá',
  exchangeCode: 'Hãy chọn hình thức thanh toán rồi nhập mã ưu đãi',
  enterExchangeCode: 'Nhập mã ưu đãi tại đây',
  exchangeText: 'Đổi',
  confirmGet: 'Xác nhận nhận',
  couponUsedWay:
    'Phiếu giảm giá chỉ hỗ trợ loại tiền và kênh nạp chỉ định, hãy xác nhận loại tiền bạn muốn dùng',
  confirmText: 'Xác nhận',
  exchangeSucc: 'Đổi thành công',
  aboutCoins: 'Về Voucher',
  aboutCoinsText:
    'Voucher có thể dùng để đổi tất cả gói quà và dịch vụ trong trò chơi trừ voucher',
  known: 'Tôi hiểu rồi',
  codeText: 'Đổi Giftcode',
  codeInvalid: 'Đổi Giftcode vô hiệu!',
  hasExchanged: 'Bạn đã đổi, giftcode chỉ có thể nhận 1 lần!',
  hideText: 'Thu gọn',
  //黑五的报错码
  'bf-20001': 'Chưa đăng nhập',
  'bf-20002': 'Lỗi tham số, hãy thử vào lại hoạt động',
  'bf-20003': 'Điểm không đủ',
  'bf-20004': 'Nhận thất bại, vui lòng thử lại hoặc liên hệ CSKH',
  'bf-20005': 'Đã Nhận',
  'bf-20015': 'HĐ chưa mở, vui lòng chờ đợi',
  'bf-20016': 'HĐ đã kết thúc',
  bfShareText: 'Nhận phiếu giảm hạn giờ 10%OFF',
  rightsCenterBtn: 'Trung Tâm Hội Viên Cao Cấp',
  payBtn: 'Thanh toán',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Vinh Quang Siêu Phàm (Vĩnh viễn)',
  rightCenterNoticeTitle: 'Về việc nâng cấp cơ chế Điểm VIP thành [Trung Tâm Quyền Lợi]', 
  rightCenterNoticeContent: 'Chỉ huy thân mến:<br />Cảm ơn sự ủng hộ của bạn trong thời gian qua! Để mang đến trải nghiệm phúc lợi tốt hơn, chúng tôi sẽ tiến hành nâng cấp toàn diện cơ chế Điểm VIP hiện có vào ngày 16/07/2025, ra mắt hệ thống Trung Tâm Hội Viên Cao Cấp hoàn toàn mới. Bản nâng cấp này sẽ tích hợp các quyền lợi VIP hiện có và bổ sung thêm nhiều phúc lợi khác, cụ thể các điều chỉnh như sau:<br />I. Nội dung nâng cấp<br />Phúc lợi đăng nhập hàng tuần được giữ nguyên<br />Từ ngày 16/07/2025 đến 29/07/2025, tất cả người chơi đăng nhập vào [Trang nạp tiền chính thức] vẫn có thể nhận được [Phiếu ưu đãi VIP hàng tuần], số lượng phiếu ưu đãi có thể nhận được đồng bộ với [Sự kiện Điểm VIP]. Đồng thời, tất cả người chơi có thể đổi phiếu ưu đãi phiên bản mới tại [Trung Tâm Hội Viên Cao Cấp], phiếu ưu đãi tại Trung tâm quyền lợi sẽ có giới hạn mức giảm giá tối đa, quy tắc phiếu ưu đãi mới và số lượng có thể nhận được có thể tham khảo bảng bên dưới.<br />Lưu ý: Tính năng tự động phát phiếu ưu đãi cần được mở thủ công, đường dẫn bật: Trang chủ Trung tâm quyền lợi - Xem quyền lợi hội viên - Tự động phát phiếu ưu đãi - Nhấn để mở - Chọn phiếu ưu đãi cần tự động đổi - Xác nhận mở<br />Thêm phúc lợi đổi điểm<br />Trung tâm quyền lợi sẽ mở tính năng "Đổi điểm", người chơi có thể tham gia đăng nhập trò chơi, hoàn thành nhiệm vụ được chỉ định tại Trung tâm quyền lợi, v.v. để nhận điểm, đổi lấy phiếu ưu đãi độc quyền, đạo cụ hiếm và các phần thưởng giá trị khác (số lượng đổi được cụ thể xem tại giao diện Trung tâm quyền lợi).<br />Bảo đảm kế thừa Cấp VIP<br />Cấp VIP ban đầu và điểm tích lũy sẽ được kế thừa toàn bộ vào Trung tâm quyền lợi và tự động chuyển đổi thành cấp độ tương ứng tại Trung tâm quyền lợi, các đặc quyền VIP ban đầu sẽ được giữ nguyên và tăng cấp.<br />II. Ưu điểm sau khi nâng cấp<br />Quyền lợi rõ ràng hơn: Mọi quy tắc ưu đãi và nội dung đổi thưởng đều được hiển thị rõ ràng, nhận thưởng nhanh, tiện lợi và không lo lắng.<br />Hoàn trả hậu hĩnh hơn: Bổ sung hoạt động đổi điểm, đạo cụ giá trị cao được cập nhật ngẫu nhiên.<br />Phúc lợi rút thưởng: Ngoài đổi điểm, còn có hoạt động rút thưởng, có thể nhận thưởng đạo cụ trong trò chơi.<br />III. Lưu ý<br />Trong thời gian chuyển đổi phiên bản (16/07/2025 - 29/07/2025), cổng Điểm VIP cũ sẽ dần đóng lại (nhưng trước khi đóng vẫn phát hành phiếu ưu đãi bình thường), vui lòng sử dụng phiếu ưu đãi còn lại kịp thời. Phiếu ưu đãi chưa sử dụng sẽ hết hạn sau khi [Sự kiện Điểm VIP] đóng lại.<br />Sau khi Trung tâm quyền lợi ra mắt, bạn có thể vào [Trung tâm quyền lợi] thông qua [Trung tâm nạp] - [Ảnh đại diện].',
  rightCenterNoticeTableTitle: 'So sánh thay đổi Coupon',
  rightCenterNoticeTableHeader1: 'Ngưỡng đổi - Cấp hội viên',
  rightCenterNoticeTableHeader2: 'Cấp độ VIP gốc',
  rightCenterNoticeTableHeader3: 'Chiết khấu phiếu ưu đãi',
  rightCenterNoticeTableHeader4: 'Giới hạn nhận',
  rightCenterNoticeTableHeader5: 'Giới hạn giảm giá',
  rightCenterNoticeTableLevel1: 'Đồng',
  rightCenterNoticeTableLevel2: 'Bạc',
  rightCenterNoticeTableLevel3: 'Vàng',
  rightCenterNoticeTableLevel4: 'Bạch Kim',
  rightCenterNoticeTableLevel5: 'Kim Cương',
  rightCenterNoticeTableCount1: '1 lần/ngày',
  rightCenterNoticeTableCount2: '15 lần/tháng',
  rightCenterNoticeTableCount3: '10 lần/tháng',
  rightCenterNoticeTableLimit: '15 USD',
  rightCenterNoticeTableTip: 'Lưu ý: Giới hạn giảm giá phiếu ưu đãi [Trung tâm quyền lợi] dựa trên USD, chịu ảnh hưởng bởi biến động tỷ giá, vui lòng xem trang sử dụng thực tế để biết chi tiết.',
  '-': '-'
};
